import apis from '@/apis'

export default {
  isSecured: true,
  baseUrl: '//noctorus.studio/october/singulo/',
  baseUrlCaptcha: '//noctorus.studio/php/',
  about (name) {
    return new Promise((resolve, reject) => {
      name = name === undefined ? 'all' : name
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('about/' + name)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  carousel (name) {
    return new Promise((resolve, reject) => {
      name = name === undefined ? 'all' : name
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('carousel/' + name)
      .then(data => {
        // reject({ error: 'error' })
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  company (name) {
    return new Promise((resolve, reject) => {
      name = name === undefined ? 'all' : name
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('company/' + name)
      .then(data => {
        // reject({ error: 'error' })
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  gallery (name) {
    return new Promise((resolve, reject) => {
      name = name === undefined ? 'all' : name
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('gallery/' + name)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  eventDetail (showId) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('event/show/' + showId)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  eventPrevious () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('event/previous')
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  eventUpcoming () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('event/upcoming')
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  email (type, recaptcha,
    name, lname, bname, phone, email, message,
    files) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      var params = {
        type: type,
        recaptcha: recaptcha,

        name: name,
        lname: lname,
        email: email,
        phone: phone,
        message: message
      }
      if (bname !== undefined) {
        params['bname'] = bname
      }
      if (files !== undefined) {
        params['files'] = files
      }
      apis.post('email', params)
      .then(data => {
        // reject({ error: 'error' })
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  subscribe (name, email) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.post('email/subscribe', { name: name, email: email })
      .then(data => {
        // reject({ error: 'error' })
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  getRecaptcha () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrlCaptcha
      apis.get('captcha.php')
      .then(data => {
        // reject({ error: 'error' })
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/apis/Singulo.js